export * from "./getters.js";
export * from "./actions.js";
export * from "./mutations";

export const SURVEYS_M = "SURVEYS/";
